import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background-color: #ebecec;\n  height: 1px;\n  margin-bottom: 36px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  margin-bottom: 15px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 20px 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  transform: rotate(", "deg);\n  transition: transform 300ms;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  padding: 16px 20px;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  text-align: left;\n  background-color: transparent;\n  border-width: 0;\n  color: #363f41;\n  cursor: pointer;\n  outline: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  border-radius: ", ";\n  border: solid 1px #cccfcf;\n  margin-bottom: 10px;\n\n  & .ReactCollapse--collapse {\n    transition: height 250ms;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import chevronSVG from '../assets/icons/chevron-gray.svg';
import styled from '../utils/styling/styled-components';
var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.borderRadius.large;
});
var Trigger = styled.button(_templateObject2());
var Chevron = styled.img(_templateObject3(), function (props) {
  return props.isOpened ? '180' : '0';
});
var Content = styled.div(_templateObject4());
var Subheader = styled.div(_templateObject5(), function (props) {
  return props.theme.colors.stone;
});
var Separator = styled.div(_templateObject6());
export var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      header = _ref.header,
      subheader = _ref.subheader,
      className = _ref.className;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpened = _useState2[0],
      setIsOpened = _useState2[1];

  var handleClick = function handleClick() {
    return setIsOpened(!isOpened);
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(Trigger, {
    onClick: handleClick
  }, header, /*#__PURE__*/React.createElement(Chevron, {
    isOpened: isOpened,
    src: chevronSVG,
    alt: "accordion"
  })), /*#__PURE__*/React.createElement(Collapse, {
    isOpened: isOpened
  }, /*#__PURE__*/React.createElement(Content, null, subheader && /*#__PURE__*/React.createElement(Subheader, null, subheader), /*#__PURE__*/React.createElement(Separator, null), children)));
};